import UtilsUrl from "../utils/UtilsUrl";
import api from "./api";




class KPIAchatService {
  getAlertsBySociete(idUserCreation) {
    return api.get(
      UtilsUrl.KpiAlerteURL() +
      "/getAlertBySociete/" +
      idUserCreation
    );
  }




  getToByYear(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiAchatURL() +
      "/getToByYear/" +
      idUserCreation +
      "/" +
      year
    );
  }
  getFicheAllClientsInfoByAnnee(idUserCreation, year) {
    return api.get(
      UtilsUrl.Account() +
      "tiersAccount/getFicheAllClientsInfoByAnnee/" +
      idUserCreation +
      "/" +
      year
    );
  }

  numberFacturePayed(idUserCreation, year) {
    return api.get(
      UtilsUrl.KpiAchatURL() +
      "/numberFacturePayed/" +
      idUserCreation +
      "/" +
      year
    );
  }


}
export default new KPIAchatService();